<template>
    <section class="grid-flex center">

        <div>
            <div class="box-content flex txt-center center">
                <div>
                    <div class="img-warning" style="margin-top: 30px">
                        <img src="@/assets/img/warning-logo.png" width="120">
                    </div>

                    <div class="margin-top-l">
                        <h2>Conta Cancelada!</h2>
                        <br>
                        <p>Sua conta foi cancelada por falta de pagamento!</p>
                        <br>
                        <p>Entre em contato pelo whatsapp abaixo:</p>
                        <br>
                        <a href="https://api.whatsapp.com/send?phone=5541984421134&text=Conta Cancelada" target="_blank">
                            <div class="button primary">
                                <span>(41) 98442-1134</span>
                            </div>
                        </a>

                        <div class="margin-top-l">
                            <a @click="logout()">
                                <div class="button secondary">
                                    <span>Sair</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: "canceled-account",
  components: {},
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
